import React from 'react';
import { CheckCircle2, TrendingUp, Ruler } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n';

export const BallControlCard = ({ ball }) => {
  const { t, lang } = useLanguage();
  if (!ball || (!ball.feedback_en && ball.avg_distance_cm == null)) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="ss-card p-5" data-testid="result-ball-control-card">
      <h2 className="font-display font-bold tracking-tight text-white flex items-center gap-2 mb-2">
        <Ruler size={15} className="text-white/60" /> {t('ballControl')}
        {ball.avg_distance_cm != null && <span className="font-mono text-xs text-white/70">~{ball.avg_distance_cm} cm</span>}
      </h2>
      <p className="text-sm text-white/75 leading-relaxed">{lang === 'it' ? ball.feedback_it : ball.feedback_en}</p>
    </motion.div>
  );
};

export const StrengthsCard = ({ report }) => {
  const { t, lang } = useLanguage();

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="ss-card p-5" data-testid="result-strengths-card">
      <h2 className="font-display font-bold tracking-tight text-white flex items-center gap-2 mb-3">
        <CheckCircle2 size={16} className="text-[#9BD770]" /> {t('strengths')}
      </h2>
      <ul className="space-y-2.5">
        {(lang === 'it' ? report.strengths_it : report.strengths_en).map((s) => (
          <li key={s} className="flex items-start gap-2.5 text-sm text-white/75 leading-relaxed">
            <span className="w-1.5 h-1.5 rounded-full bg-[#9BD770] mt-1.5 shrink-0" />
            {s}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export const SuggestionsCard = ({ report }) => {
  const { t, lang } = useLanguage();

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.16 }} className="ss-card p-5" data-testid="result-suggestions-card">
      <h2 className="font-display font-bold tracking-tight text-white flex items-center gap-2 mb-3">
        <TrendingUp size={16} className="text-white/60" /> {t('suggestions')}
      </h2>
      <ul className="space-y-2.5">
        {(lang === 'it' ? report.suggestions_it : report.suggestions_en).map((s, i) => (
          <li key={s} className="flex items-start gap-2.5 text-sm text-white/75 leading-relaxed">
            <span className="font-mono text-[10px] text-white/50 border border-white/20 rounded-[10px] px-1 mt-0.5 shrink-0">{String(i + 1).padStart(2, '0')}</span>
            {s}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};
